/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterTeacherDto } from '../../models/center-teacher-dto';

export interface CenterUserControllerGetTeachers$Params {
  centerId: string;
}

export function centerUserControllerGetTeachers(http: HttpClient, rootUrl: string, params: CenterUserControllerGetTeachers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterTeacherDto>>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerGetTeachers.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterTeacherDto>>;
    })
  );
}

centerUserControllerGetTeachers.PATH = '/api/center-user/teachers';
